/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="69.86" height="95.58" viewBox="0 0 69.86 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path fill="none" stroke="#0e497b" d="M34.93 1.25A33.68 33.68 0 0 0 1.25 34.93c0 26.81 33.68 59.4 33.68 59.4s33.68-32.59 33.68-59.4A33.68 33.68 0 0 0 34.93 1.25Z" strokeWidth="2.5" strokeLinejoin="round"/>
        <path fill="#ffb81c" d="M34.93 15.82a18.62 18.62 0 1 0 18.62 18.61 18.61 18.61 0 0 0-18.62-18.61Zm0 2.5a16.12 16.12 0 1 1-16.11 16.11 16.12 16.12 0 0 1 16.11-16.11Z"/>
      </svg>
    );
  }
}

Icon.displayName = 'MapPinIcon';

export default Icon;
